import { FC } from 'react';
import { FormCurrencyFieldProps } from './types';
import { CalculatorHeading, CalculatorText, FormCurrencyField, FormSelect } from 'components/common';
import { useIntl } from 'react-intl';
import { ISelectOption } from '../Select/types';

export const CalculatorCurrencyField: FC<FormCurrencyFieldProps> = ({
  name,
  textKey,
  titleKey,
  rules,
  className,
  isPeriod,
  periodProps,
  textHref,
  textFieldProps,
  shouldShowAdornment = false,
}) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <CalculatorHeading labelKey={titleKey} />
      {textKey && <CalculatorText labelKey={textKey} href={textHref} />}
      <div className={'mt-2 flex'}>
        <FormCurrencyField
          name={name}
          textFieldProps={{ ...textFieldProps, placeholder: intl.formatMessage({ id: 'numbers.0' }) }}
          numericFormatProps={{ decimalScale: 0 }}
          rules={rules}
          shouldShowAdornment={shouldShowAdornment}
        />
        {isPeriod && periodProps && (
          <FormSelect
            name={name + 'Period'}
            className={'xs:ml-2 xs:w-3/5 md:ml-6 md:w-1/3'}
            rules={periodProps.rules}
            options={periodProps.options}
            selectProps={{
              isOptionEqualToValue: (option: ISelectOption, selectedOption: ISelectOption) =>
                option.value === selectedOption.value,
              ...periodProps.selectProps,
            }}
            selectInputProps={{
              placeholder: intl.formatMessage({ id: periodProps?.placeholderKey || 'placeholders.select' }),
            }}
          />
        )}
      </div>
    </div>
  );
};
